import { type as typeUtil } from '@mews/framework';

export function Message({
    id = null,
    creatorProfileId,
    text = '',
    created,
    isStub = false,
    isFailed = false,
}: $TSFixMe = {}) {
    return typeUtil.create(Message, {
        id,
        creatorProfileId,
        text,
        created,
        isStub,
        isFailed,
    });
}
